import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../../features/auth/authSlice";

const Error403 = () => {
   const dispatch = useDispatch();
   const navigate = useNavigate();
   const handleBack = async () => {
      try {
         await dispatch(logout());
      } finally {
         navigate("/login", { replace: true });
      }
   };
   return (
      <div className="authincation h-100 p-meddle">
         <div className="container h-100">
            <div className="row justify-content-center h-100 align-items-center ">
               <div className="col-md-5">
                  <div className="form-input-content text-center error-page">
                     <h1 className="error-text  font-weight-bold">403</h1>
                     <h4>
                        <i className="fa fa-times-circle text-danger" />{" "}
                        Yetkiniz yok
                     </h4>
                     <p>Bu kaynağı görüntüleme izniniz yok.</p>
                     <div>
                        <button type="button" className="btn btn-primary" onClick={handleBack}>
                           Back to Home
                        </button>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};

export default Error403;
